/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Restore destination type.
*/
export enum QueryDBRestoreDestinationType {
  S3 = 'S3',
  Gcs = 'GCS',
  StorageAccountContainer = 'STORAGE_ACCOUNT_CONTAINER'
}
